import { useEffect } from 'react';
import { WithRouterProps } from '@client/router/compat';

import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { useCustomizations } from '@client/new/hooks/use-customizations';
import { PATHS, replacePath } from '@client/paths';

import { PrototypeHostView } from './view/PrototypeHost.view';

export const ExercisesCatalogPage = (p: WithRouterProps) => {
  const influencerId = p.params?.influencerId;
  const { isLoading, error, customizations } = useCustomizations(
    influencerId ?? null,
  );
  const isEnabled = !error && customizations?.exercisesCatalogEnabled === true;
  const shouldRedirect = !isLoading && !isEnabled;

  useEffect(() => {
    if (shouldRedirect) replacePath(PATHS.LIBRARY(influencerId));
  }, [shouldRedirect, influencerId]);

  if (isLoading || !isEnabled) return <TableLoader />;

  return <PrototypeHostView creatorId={Number(influencerId)} />;
};
